import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Loader} from '@flexe/ui-components';
import {useEffect} from 'react';
import {Warehouse} from '../../shared/CommonInterfaces';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import InboundsIndex from '../shared/index-page/InboundsIndex';

interface InboundsAppProps {
  authenticityToken: string;
  availableWarehouses: Warehouse[];
}

const InboundsApp: React.FC<InboundsAppProps> = (props) => {
  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  const [selectedWarehouse, setSelectedWarehouse] = React.useState<Warehouse>(null);
  const [warehouseLoading, setWarehouseLoading] = React.useState<boolean>(true);
  const [hasError, setHasError] = React.useState<boolean>(false);

  useEffect(() => {
    // Default to first warehouse for shipper
    if (props.availableWarehouses.length > 0) {
      setSelectedWarehouse(props.availableWarehouses[0]);
      setHasError(false);
    } else {
      setSelectedWarehouse(null);
      setHasError(true);
    }
    setWarehouseLoading(false);
  }, [props.availableWarehouses]);

  const handleWarehouseChange = (newWarehouse: Warehouse) => {
    setSelectedWarehouse(newWarehouse);
    // Data will automatically refetch due to useEffect dependency in InboundsIndex
  };

  const renderContent = () => {
    if (warehouseLoading) {
      return <Loader loading={true} />;
    }

    if (hasError || !selectedWarehouse) {
      return (
        <div className="alert alert-danger" style={{margin: '20px'}}>
          <p>No warehouse found. Could not load inbound details. Please contact support if this issue persists.</p>
        </div>
      );
    }

    return (
      <InboundsIndex
        selectedWarehouse={selectedWarehouse}
        isShipper={true}
        availableWarehouses={props.availableWarehouses}
        onWarehouseChange={handleWarehouseChange}
        authenticityToken={props.authenticityToken}
      />
    );
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <Router>
        <Switch>
          <Route path="/s/inbounds" exact render={() => renderContent()} />
        </Switch>
      </Router>
    </FlexeContext.Provider>
  );
};

export default InboundsApp;
